<template>
  <n-layout-sider
    bordered
    collapse-mode="width"
    :collapsed-width="64"
    :width="200"
    :collapsed="collapsed"
    show-trigger
    @collapse="collapsed = true"
    @expand="collapsed = false"
    style="transition: all 0.3s ease;"
  >

    <n-menu
      :options="menuOptions"
      :collapsed="collapsed"
      :collapsed-width="64"
      @update:value="goTo"
    />
  </n-layout-sider>
</template>

<script setup>
import { ref } from 'vue'
import { useRouter } from 'vue-router'

const router = useRouter()
const collapsed = ref(false)

const menuOptions = [
  {
    label: 'Dashboards',
    key: '/',
    icon: () => '📈'
  },
  {
    label: 'Beacons',
    key: '/beacons',
    icon: () => '🛜'
  },
  {
    label: 'Configurações',
    key: '/settings',
    icon: () => '⚙️'
  },
  {
    label: 'Técnicos',
    key: '/tecnicos',
    icon: () => '👷🏻'
  },
  {
    label: 'Chamados',
    key: '/chamados',
    icon: () => '🖥️'
  },
  {
    label: 'Agendamentos',
    key: '/agendamentos',
    icon: () => '📅'
  },
  {
    label: 'Associações',
    key: '/associacoes',
    icon: () => '📲'
  },
]

function goTo(key) {
  router.push(key)
}

function toggleCollapse() {
  collapsed.value = !collapsed.value
}
</script>

<style scoped>
.flex {
  display: flex;
}
.items-center {
  align-items: center;
}
.justify-center {
  justify-content: center;
}
.border-b {
  border-bottom: 1px solid var(--border-color, #e0e0e0);
}
</style>
